export default __webpack_public_path__ + "static/media/EggScone.4ca55afd.png";